<template>
  <div
    class="modal right fade"
    id="myModal2"
    tabindex="-1"
    aria-labelledby="myModalLabel2"
    data-bs-keyboard="false"
    data-bs-backdrop="static"
    style="display: block"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" aria-label="Close" @click.prevent="handleDialogClose">
            <span aria-hidden="true"
              ><i class="fa fa-times" aria-hidden="true" style="background-color: #0054a6; color: white"></i
            ></span>
          </button>
          <span id="myModalLabel2" style="background-color: #0054a6; color: white">{{ Title }}</span>
        </div>

        <div class="modal-body">
          <div class="content">
            <AlertComponent
              v-if="isCancelButtonClicked"
              @setWindow="($emit('visibleEditDialog', false), (showEditPopupLocal = false), backdropClose())"
              :isCancelButtonClicked="isCancelButtonClicked"
              @hidePopup="isCancelButtonClicked = false"
            ></AlertComponent>
            <div class="body">
              <div class="customSettingName">
                <label for="basic-url" style="font-size: 16px">{{ $t("editCustomSetting.name") }}</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="basic-url"
                    v-model="customSettings.name"
                    style="border-radius: 10px"
                    aria-describedby="basic-addon3"
                    disabled
                  />
                </div>
                <span class="counter">{{ customSettings.name ? customSettings.name.length : 0 }}/20</span>
              </div>
              <div class="tktTex">
                <label for="basic-url" style="font-size: 16px">{{ $t("editCustomSetting.tktTex") }}</label>
                <div class="input-group mb-3">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      v-model="customSettings.tktTex"
                      value="Tkt"
                      checked
                      :disabled="customSettings.name == 'Default'"
                    />
                    <label class="form-check-label" for="inlineRadio1">{{ $t("editCustomSetting.tkt") }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio2"
                      v-model="customSettings.tktTex"
                      value="Tex"
                      :disabled="customSettings.name == 'Default'"
                    />
                    <label class="form-check-label" for="inlineRadio2">{{ $t("editCustomSetting.tex") }}</label>
                  </div>
                </div>
              </div>
              <div class="allowance">
                <label class="form-check-label" for="customRange3" style="font-size: 16px">{{
                  $t("editCustomSetting.allowance")
                }}</label>
                <output style="position: absolute; right: 20px">{{ customSettings.defaultAllowance }}%</output>
                <input
                  type="range"
                  class="custom-range"
                  min="0"
                  max="50"
                  step="1"
                  v-model="customSettings.defaultAllowance"
                  id="customRange3"
                  :disabled="customSettings.name == 'Default'"
                />
              </div>
              <div v-if="customSettings.name != 'Default'" class="defaultSetting mt-3">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="inlineRadioOptions"
                    id="inlineCheckBox3"
                    v-model="customSettings.isDefaultSettingId"
                    style="border: 1px solid black"
                  />
                  <label class="form-check-label" for="inlineCheckBox3">{{
                    $t("editCustomSetting.setAsMyDefaultSetting")
                  }}</label>
                </div>
              </div>
              <div class="buttons" style="margin-top: 10px">
                <button
                  v-if="customSettings.name != 'Default'"
                  class="btn btn-sm btn-primary mt-2"
                  style="width: 7rem; border-radius: 4px"
                  @click="updateCustomSetting"
                >
                  {{ $t("operationCreateComp.save") }}
                </button>
                <button
                  v-if="customSettings.name != 'Default'"
                  class="btn btn-sm btn-secondary mt-2"
                  style="width: 8rem; border-radius: 4px; margin-left: 10px"
                  @click="handleDialogClose"
                >
                  {{ $t("operationCreateComp.cancel") }}
                </button>
              </div>
              <hr style="width: 100%; text-align: left; margin-left: 0; border-top: 2px solid rgba(0, 0, 0, 0.2)" />
              <label for="basic-url" style="font-size: 16px">{{ $t("editCustomSetting.stitchType") }}</label>
              <div class="search stitchTypeRow">
                <div class="stitchType">
                  <ComboBox
                    ref="stitchData"
                    :data-source="stitchTypeData"
                    :height="275"
                    :maxlength="30"
                    :filter="'contains'"
                    :placeholder="'Select Stitch Type'"
                    @change="setStitchComponentValue($event.sender._cascadedValue)"
                  >
                  </ComboBox>
                </div>
              </div>
              <div v-if="lastChnagedBy != '' && showStitchData" class="lastChanged">
                {{ $t("editCustomSetting.lastChangedBy") }} : {{ lastChnagedBy }}, {{ $t("editCustomSetting.date") }} :
                {{ lastchangedDate }}, {{ $t("editCustomSetting.time") }} : {{ lastChangedTime }}
              </div>
              <div v-if="showStitchData" class="stitchComponent">
                <div class="leftComponent">
                  <table
                    style="border-spacing: 7px 0px; table-layout: auto; border-collapse: separate; width: 100%"
                    aria-hidden="true"
                  >
                    <tbody>
                      <tr>
                        <td v-if="editStitchComponentData.rateRequired">
                          <label
                            style="font-size: 14px; text-align: start; white-space: nowrap"
                            v-if="seamUnitDefaultValue == 'Imperial' && editStitchComponentData.rateRequired"
                            for="stitchRate"
                            >{{ $t("styleGrid.stitch") }}/Inch</label
                          >
                          <label
                            style="font-size: 14px; text-align: start; white-space: nowrap"
                            v-if="seamUnitDefaultValue == 'Metric' && editStitchComponentData.rateRequired"
                            for="stitchRate"
                            >{{ $t("styleGrid.stitch") }}/3CM</label
                          >
                        </td>
                        <td v-if="editStitchComponentData.seamThiknessRequired">
                          <label
                            style="font-size: 14px; text-align: start; white-space: nowrap"
                            v-if="editStitchComponentData.seamThiknessRequired"
                            for="seamThickness"
                            >{{ $t("operationListComp.seamThickness") }}(mm)</label
                          >
                        </td>
                      </tr>
                      <tr>
                        <td v-if="editStitchComponentData.rateRequired">
                          <input
                            v-if="editStitchComponentData.rateRequired"
                            class="stitch"
                            style="text-align: right"
                            type="number"
                            min="0"
                            step=".01"
                            max="50"
                            v-model="editStitchComponentData.stdStitchRate"
                            :disabled="customSettings.name == 'Default'"
                            id="stitchRate"
                          />
                        </td>
                        <td v-if="editStitchComponentData.seamThiknessRequired">
                          <input
                            v-if="editStitchComponentData.seamThiknessRequired"
                            class="stitch"
                            style="text-align: right"
                            type="number"
                            min=".1"
                            step=".01"
                            max="999.99"
                            v-model="editStitchComponentData.seamThikness"
                            :disabled="customSettings.name == 'Default'"
                            id="seamThickness"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="rightComponent">
                  <table style="border-collapse: separate; border-spacing: 7px 0px" aria-hidden="true">
                    <tbody>
                      <tr>
                        <td v-if="showBight">
                          <label
                            style="text-align: start; font-size: 14px"
                            v-if="seamUnitDefaultValue == 'Imperial' && showBight"
                            for="bight"
                            >{{ $t("editCustomSetting.bight") }}(Inch)</label
                          >
                          <label
                            style="text-align: start; font-size: 14px"
                            v-if="seamUnitDefaultValue == 'Metric' && showBight"
                            for="bight"
                            >{{ $t("editCustomSetting.bight") }}(Cm)</label
                          >
                        </td>
                        <td style="padding: 0">
                          <label style="text-align: start; font-size: 14px" for="defaultWaste"
                            >{{ $t("editCustomSetting.waste") }}(%)</label
                          >
                        </td>
                      </tr>
                      <tr>
                        <td v-if="showBight">
                          <input
                            v-if="showBight"
                            class="stitch"
                            style="text-align: right"
                            step=".01"
                            type="number"
                            v-model="editStitchComponentData.defaultBight"
                            :disabled="customSettings.name == 'Default'"
                            id="bight"
                          />
                        </td>
                        <td style="padding: 0">
                          <input
                            class="stitch"
                            style="text-align: right"
                            type="number"
                            min="0"
                            max="999"
                            step=".01"
                            v-model="editStitchComponentData.defaultwaste"
                            :disabled="customSettings.name == 'Default'"
                            id="defaultWaste"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr v-if="showStitchData" style="width: 100%; text-align: left; margin-left: 0" />
              <div v-if="needleData.length > 0 && showStitchData" class="consumption">
                <table class="consumptionTable mt-4">
                  <thead>
                    <tr>
                      <th scope="col">{{ $t("editCustomSetting.threadComponent") }}</th>
                      <th scope="col" class="num">{{ consumptionHeader }}</th>
                      <th scope="col" class="op"></th>
                      <th scope="col" class="num">{{ $t("editCustomSetting.wastageAdded") }}</th>
                      <th scope="col" class="op"></th>
                      <th scope="col" class="num right">{{ $t("editCustomSetting.totalAfterWastage") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="item" v-for="(item, id) in needleData" :key="id">
                      <td class="component">{{ needleData[id] }}</td>
                      <td class="num">
                        <input
                          class="consumptionData"
                          type="number"
                          min="1"
                          max="99999.9"
                          step="0.01"
                          v-model.number="consumptionValues[id]"
                          :disabled="customSettings.name == 'Default' || needleData[id] === 'Gimp'"
                          :id="`consumptionData-${id}`"
                          :aria-label="`${needleData[id]} consumption`"
                        />
                        <span class="unit">{{ lengthUnitLabel }}</span>
                      </td>
                      <td class="op">+</td>
                      <td class="num">
                        <div class="strongValue">{{ wastageValues[id].toFixed(2) }} {{ lengthUnitLabel }}</div>
                        <div v-if="isAllowanceUsed" class="allowanceNote">
                          {{ $t("editCustomSetting.allowanceShort", { percentage: effectiveWaste.toFixed(2) }) }}
                        </div>
                      </td>
                      <td class="op">=</td>
                      <td class="num right strongValue">{{ totalValues[id].toFixed(2) }} {{ lengthUnitLabel }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td class="component">{{ totalsLabel }}</td>
                      <td class="num">{{ consumptionTotal.toFixed(2) }} {{ lengthUnitLabel }}</td>
                      <td class="op"></td>
                      <td class="num">{{ wastageTotal.toFixed(2) }} {{ lengthUnitLabel }}</td>
                      <td class="op"></td>
                      <td class="num right">{{ totalAfterWastageTotal.toFixed(2) }} {{ lengthUnitLabel }}</td>
                    </tr>
                  </tfoot>
                </table>
                <div class="consumptionNote">
                  {{
                    $t("editCustomSetting.wastageFormulaNote", {
                      consumption: consumptionHeader,
                      source: wasteSourceLabel,
                      percentage: effectiveWaste.toFixed(2)
                    })
                  }}
                </div>
                <div v-if="isAllowanceUsed" class="allowanceMessage">
                  {{ $t("editCustomSetting.allowanceUsedNote", { percentage: effectiveWaste.toFixed(2) }) }}
                </div>
                <table style="width: 100%" aria-hidden="true">
                  <tbody>
                    <tr>
                      <td>
                        <div style="float: right">
                          <button
                            v-if="customSettings.name != 'Default'"
                            class="btn btn-sm btn-primary mt-4"
                            style="border-radius: 4px; width: 8em; margin-right: 5px"
                            @click="updateStitchData"
                          >
                            {{ $t("editCustomSetting.update") }}
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ComboBox } from "@progress/kendo-dropdowns-vue-wrapper";
import { CustomSettingsApi, StitchTypeApi, StitchNBLCTypesApi } from "@/api";
import { StitchTypeDto } from "@/api/model";
import AlertComponent from "./AlertComponent.vue";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";
import { getConsumptionHeader, withSeamLengthSuffix } from "@/core/utils/ConsumptionHelper";

const round2 = (v: number): number => Math.round(v * 100) / 100;

export default defineComponent({
  name: "EditCustomSetting",
  emits: ["visibleEditDialog", "getCustomSettingsData", "save"],
  components: {
    ComboBox,
    AlertComponent
  },
  props: {
    showEditPopup: Boolean,
    customSettingId: null as any,
    seamUnitDefaultValue: null as any,
    seamLengthUnit: null as any
  },
  setup() {
    const customSettingsApi = new CustomSettingsApi()!;
    const stitchTypeApi = new StitchTypeApi()!;
    const stitchNBLCTypesApi = new StitchNBLCTypesApi()!;
    return {
      customSettingsApi,
      stitchTypeApi,
      stitchNBLCTypesApi
    };
  },
  data() {
    return {
      showEditPopupLocal: this.showEditPopup,
      toast: useToast(),
      customSettings: [] as any,
      stitchTypeData: [] as any,
      stitchComponentData: [] as any,
      editStitchComponentData: {} as StitchTypeDto,
      stitchTypeName: "",
      lastChnagedBy: "",
      lastchangedDate: "",
      lastChangedTime: "",
      Title: "",
      showBight: true,
      showStitchData: false,
      bightConversionFactor: 1,
      needleData: [] as any,
      componentsData: [] as any,
      consumptionValues: [] as any,
      isCancelButtonClicked: false,
      needleError: false,
      underError: false,
      topError: false,
      tensionError: false,
      wasteError: false,
      bightError: false,
      stitchRateError: false,
      consumptionLabel: "",
      seamThiknessError: false,
      rateConversionFactor: 1,
      consumptionError: false,
      // the Allowance as it is stored, not the slider position. The consumption figures
      // come back from the server calculated with this one, so the wastage must be
      // stripped out with the same value even if the slider has been moved but not saved.
      savedAllowance: 0
    };
  },
  created(): any {
    this.getCustomSetting();
    this.getStitchTypeData();
    this.getConsumptionData();
    this.setConversionFactor();
  },
  computed: {
    consumptionHeader(): string {
      const stitchCode = this.stitchTypeName?.split("-")[0];
      return getConsumptionHeader(this.seamLengthUnit, stitchCode);
    },
    // "Total thread 10 cm", or just "Total thread" for the per-piece stitch types
    totalsLabel(): string {
      const stitchCode = this.stitchTypeName?.split("-")[0];
      return withSeamLengthSuffix(this.$t("editCustomSetting.totalThread") as string, this.seamLengthUnit, stitchCode);
    },
    lengthUnitLabel(): string {
      return this.seamUnitDefaultValue === "Imperial" ? "IN" : "CM";
    },
    // the Allowance applies only when Waste(%) is blank or zero
    isAllowanceUsed(): boolean {
      return (Number(this.editStitchComponentData.defaultwaste) || 0) === 0;
    },
    // the field the wastage percentage was taken from, named in the formula note
    wasteSourceLabel(): string {
      const key = this.isAllowanceUsed ? "editCustomSetting.globalAllowance" : "editCustomSetting.wastage";
      return this.$t(key) as string;
    },
    // what the user sees. Follows the Allowance slider as it is moved.
    effectiveWaste(): number {
      const waste = Number(this.editStitchComponentData.defaultwaste) || 0;
      return waste !== 0 ? waste : Number(this.customSettings.defaultAllowance) || 0;
    },
    // the percentage the server used to build the figures we were given. Read the
    // stored Waste, not the typed one, as the top Save writes the Allowance without
    // writing the Waste and the two would then no longer cancel each other out.
    effectiveWasteOnServer(): number {
      const code = this.stitchTypeName?.split("-")[0];
      const saved = this.stitchComponentData.find((a: { code: string }) => a.code == code);
      const waste = Number(saved?.defaultwaste) || 0;
      return waste !== 0 ? waste : this.savedAllowance;
    },
    // each row is rounded to two decimals before the column totals are added
    visibleConsumption(): number[] {
      return this.consumptionValues.slice(0, this.needleData.length).map((v: any) => round2(Number(v) || 0));
    },
    wastageValues(): number[] {
      return this.visibleConsumption.map((v: number) => round2((v * this.effectiveWaste) / 100));
    },
    totalValues(): number[] {
      return this.visibleConsumption.map((v: number, i: number) => round2(v + this.wastageValues[i]));
    },
    consumptionTotal(): number {
      return round2(this.visibleConsumption.reduce((a: number, b: number) => a + b, 0));
    },
    wastageTotal(): number {
      return round2(this.wastageValues.reduce((a: number, b: number) => a + b, 0));
    },
    totalAfterWastageTotal(): number {
      return round2(this.totalValues.reduce((a: number, b: number) => a + b, 0));
    }
  },
  mounted() {
    if (this.showEditPopupLocal) {
      this.$nextTick(() => {
        ($("#myModal2") as any).modal("show");
      });
    }
  },
  methods: {
    handleDialogClose() {
      this.isCancelButtonClicked = true;
    },
    backdropClose() {
      if (!this.showEditPopupLocal) {
        setTimeout(() => {
          const backdrop = document.querySelector(".modal-backdrop");
          if (backdrop) backdrop.remove();

          document.body.classList.remove("modal-open");
          document.body.style.removeProperty("padding-right");
          document.body.style.removeProperty("overflow");
        }, 300);
      }
    },
    setConversionFactor(): void {
      if (this.seamUnitDefaultValue == "Imperial") {
        this.bightConversionFactor = 2.54;
        this.rateConversionFactor = 1.181103;
      }
    },
    async getCustomSetting(): Promise<void> {
      await this.customSettingsApi.apiGetCustomSettingByIdGet(this.customSettingId).then(res => {
        this.customSettings = res.data;
        this.savedAllowance = Number(res.data.defaultAllowance) || 0;
        this.Title = this.$t("editCustomSetting.customSetting") + ": " + res.data.name;
      });
    },
    async getStitchTypeData(): Promise<void> {
      this.stitchTypeData = [];
      await this.stitchTypeApi.apiGetStitchTypesOrderByMostFrequentlyUsedGet(this.customSettingId).then(async res => {
        this.stitchComponentData = res.data;
        for (let product of res.data) {
          this.stitchTypeData.push(product.code + "-" + product.name);
        }
      });
    },
    setSeamThiknessAndStitchRate(stitchValue: any) {
      if (stitchValue.rateRequired) {
        this.editStitchComponentData.rateRequired = stitchValue.rateRequired;
        this.editStitchComponentData.stdStitchRate = (stitchValue.stdStitchRate / this.rateConversionFactor).toFixed(
          2
        ) as unknown as number;
      } else {
        this.editStitchComponentData.rateRequired = false;
        this.editStitchComponentData.stdStitchRate = 0;
      }
      if (stitchValue.seamThiknessRequired) {
        this.editStitchComponentData.seamThiknessRequired = stitchValue.seamThiknessRequired;
        this.editStitchComponentData.seamThikness = stitchValue.seamThikness;
      } else {
        this.editStitchComponentData.seamThiknessRequired = false;
        this.editStitchComponentData.seamThikness = 0;
      }
    },
    setStitchComponentValue(value: string): void {
      if (value == "") {
        this.editStitchComponentData = {};
        this.lastChnagedBy = "";
        this.lastchangedDate = "";
        this.lastChangedTime = "";
        this.showBight = false;
        this.showStitchData = false;
        this.getStitchTypeData();
        return;
      }
      this.showBight = true;
      this.stitchTypeName = value;
      let stitchCode = this.stitchTypeName?.split("-")[0];
      let stitchValue = this.stitchComponentData.find((a: { code: string }) => a.code == stitchCode);
      if (stitchValue != undefined) {
        this.editStitchComponentData.id = stitchValue.id;
        this.editStitchComponentData.defaultBight = (stitchValue.defaultBight / this.bightConversionFactor).toFixed(
          2
        ) as unknown as number;
        this.editStitchComponentData.defaultwaste = stitchValue.defaultwaste.toFixed(2);
        if (stitchValue.noNeedleA == 1) {
          this.editStitchComponentData.defaultcm0 = stitchValue.defaultcm0;
        } else {
          this.editStitchComponentData.defaultcm0 = 0;
        }
        if (stitchValue.noUnderA == 1) {
          this.editStitchComponentData.defaultcm1 = stitchValue.defaultcm1;
        } else {
          this.editStitchComponentData.defaultcm1 = 0;
        }
        if (stitchValue.noTopCover == 1) {
          this.editStitchComponentData.defaultcm2 = stitchValue.defaultcm2;
        } else {
          this.editStitchComponentData.defaultcm2 = 0;
        }
        this.setSeamThiknessAndStitchRate(stitchValue);
        this.lastChnagedBy = stitchValue.lastChangedBy;
        if (stitchValue.lastModificationTime != null) {
          this.lastchangedDate = stitchValue.lastModificationTime?.split("T")[0];
          this.lastChangedTime = stitchValue.lastModificationTime?.split("T")[1].split(".")[0];
        }
        this.showStitchData = true;
        this.getNeedleData(stitchCode);
        this.setConsumptionValues(stitchCode);
        this.removingNonRequiredField();
      }
    },
    async getNeedleData(code: string): Promise<void> {
      this.needleData = [];
      await this.stitchNBLCTypesApi.apiGetStitchNeedlesByStitchTypeCodeGet(code).then(res => {
        this.needleData = res.data;
      });
    },
    async getConsumptionData(code: string | null = null): Promise<void> {
      await this.stitchTypeApi
        .apiCalculateNeedlesLengthForAllStitchTypesGet(this.customSettingId, code ?? undefined)
        .then(res => {
          if (code) {
            this.componentsData = { ...this.componentsData, ...res.data };
          } else {
            this.componentsData = res.data;
          }
        });
    },
    setConsumptionValues(code: string): void {
      const conversionFactor = this.seamUnitDefaultValue === "Imperial" ? 2.54 : 1;
      const max = Math.floor((99999.9 / conversionFactor) * 100) / 100;
      // the figures from the server include the wastage. Take it back out so the
      // Consumption per 10 CM column shows the base value the user can edit.
      const wastageFactor = 1 + this.effectiveWasteOnServer / 100;
      const clamp = (v: any) => (v == null ? v : Math.min(round2(Number(v) / wastageFactor), max));
      this.consumptionValues = [];
      this.consumptionValues = [
        clamp(this.componentsData[code].headType1Consumption),
        clamp(this.componentsData[code].headType2Consumption),
        clamp(this.componentsData[code].headType3Consumption),
        clamp(this.componentsData[code].headType4Consumption)
      ];
    },
    async removingNonRequiredField(): Promise<void> {
      switch (this.stitchTypeName?.split("-")[0]) {
        case "1012":
        case "1016":
        case "3012":
        case "3042":
        case "4042":
        case "101":
        case "102":
        case "1014":
        case "103":
        case "104":
        case "105":
        case "107":
        case "108":
        case "201":
        case "204":
        case "205":
        case "206":
        case "209":
        case "211":
        case "213":
        case "214":
        case "215":
        case "217":
        case "219":
        case "220":
        case "317":
        case "318":
        case "404":
        case "405":
        case "411":
        case "412":
        case "413":
        case "414":
        case "415":
        case "416":
        case "417":
        case "1013":
        case "3013":
        case "3043":
        case "4012":
        case "4013":
        case "4013G":
        case "4043":
        case "1015":
        case "109":
        case "3015":
        case "3045":
        case "4041":
        case "4045":
        case "4012G":
        case "301":
        case "319":
        case "401":
        case "401A": {
          this.showBight = false;
          break;
        }
        default: {
          break;
        }
      }
    },
    validateDefaultWaste() {
      const defaultWaste = Number(this.editStitchComponentData.defaultwaste);
      const defaultWasteString = String(this.editStitchComponentData.defaultwaste);
      if (defaultWaste < 0 || defaultWaste > 999 || defaultWasteString == "") {
        this.wasteError = true;
        return;
      }
      if (Number.isInteger(defaultWaste)) {
        this.wasteError = false;
        return;
      }
      this.wasteError = defaultWasteString.split(".")[1]?.length > 2;
    },
    validateDefaultcm0() {
      const value = this.editStitchComponentData.defaultcm0;
      const num = Number(value);
      if (String(value) === "" || Number.isNaN(num) || num < 0) this.needleError = true;
      else this.needleError = false;
    },
    validateDefaultcm1() {
      const value = this.editStitchComponentData.defaultcm1;
      const num = Number(value);

      if (String(value) === "" || Number.isNaN(num) || num < 0) this.underError = true;
      else this.underError = false;
    },
    validateDefaultcm2() {
      const value = this.editStitchComponentData.defaultcm2;
      const num = Number(value);
      if (String(value) === "" || Number.isNaN(num) || num < 0) this.topError = true;
      else this.topError = false;
    },
    validateDefaultcm3() {
      const value = this.editStitchComponentData.defaultcm3;
      const num = Number(value);
      if (String(value) === "" || Number.isNaN(num) || num < 0) this.tensionError = true;
      else this.tensionError = false;
    },
    validateBight() {
      const defaultBight = Number(this.editStitchComponentData.defaultBight);
      const defaultBightString = String(this.editStitchComponentData.defaultBight);
      if (defaultBight < 0 || defaultBightString == "") {
        this.bightError = true;
        return;
      }
      if (Number.isInteger(defaultBight)) {
        this.bightError = false;
        return;
      }
      this.bightError = defaultBightString.split(".")[1]?.length > 2;
    },
    validateStitchRate() {
      const stitchRate = Number(this.editStitchComponentData.stdStitchRate);
      let maxStitchRate = 50;
      if (this.seamUnitDefaultValue == "Imperial") {
        maxStitchRate = 42.33;
      }
      if (
        Number.isNaN(stitchRate) ||
        String(this.editStitchComponentData.stdStitchRate) === "" ||
        stitchRate < 0 ||
        stitchRate > maxStitchRate
      )
        this.stitchRateError = true;
      else this.stitchRateError = false;
    },
    validateSeamThikness() {
      const seamThikness = Number(this.editStitchComponentData.seamThikness);
      if (
        this.editStitchComponentData.seamThiknessRequired &&
        (Number.isNaN(seamThikness) ||
          String(this.editStitchComponentData.seamThikness) === "" ||
          seamThikness < 0.1 ||
          seamThikness > 999.99)
      )
        this.seamThiknessError = true;
      else this.seamThiknessError = false;
    },
    validateConsumptionValues() {
      this.consumptionError = false;
      const conversionFactor = this.seamUnitDefaultValue === "Imperial" ? 2.54 : 1;
      const max = Math.floor((99999.9 / conversionFactor) * 100) / 100;
      for (const [index, value] of this.consumptionValues.entries()) {
        const isEditable = index < this.needleData.length && this.needleData[index] !== "Gimp";
        const isEmpty = value === null || value === undefined || value === "" || Number.isNaN(value);
        if (isEditable && (isEmpty || value < 1 || value > max)) {
          this.consumptionError = true;
          this.toast.error(this.$t("editCustomSetting.pleaseEnterCorrectConsumptionValue", { max: max }) as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
          break;
        }
      }
    },
    validateStitchComponentData(): void {
      this.validateDefaultWaste();
      this.validateStitchRate();
      this.validateSeamThikness();
      this.validateBight();
      this.validateConsumptionValues();
    },
    async updateStitchData(): Promise<void> {
      this.validateStitchComponentData();
      if (
        !this.bightError &&
        !this.wasteError &&
        !this.stitchRateError &&
        !this.seamThiknessError &&
        !this.consumptionError
      ) {
        this.editStitchComponentData.settingId = this.customSettingId;
        this.editStitchComponentData.code = this.stitchTypeName?.split("-")[0];
        const newWaste = Number(this.editStitchComponentData.defaultwaste);
        const inputBight = Number(this.editStitchComponentData.defaultBight) * this.bightConversionFactor;
        const newStitchRate =
          Math.round(Number(this.editStitchComponentData.stdStitchRate) * this.rateConversionFactor * 10000) / 10000;
        let tensionValuesFailed = false;
        await this.stitchTypeApi
          .apiCalculateTensionValuesForStitchTypeGet(
            this.editStitchComponentData.seamThikness ?? undefined,
            this.editStitchComponentData.code as string,
            this.customSettingId,
            this.consumptionValues[0],
            this.consumptionValues[1],
            this.consumptionValues[2],
            this.consumptionValues[3],
            newWaste,
            newStitchRate,
            inputBight
          )
          .then(res => {
            this.editStitchComponentData.defaultcm0 = Number(res.data.headType1Tension ?? 100);
            this.editStitchComponentData.defaultcm1 = Number(res.data.headType2Tension ?? 100);
            this.editStitchComponentData.defaultcm2 = Number(res.data.headType3Tension ?? 100);
            this.editStitchComponentData.defaultcm3 = Number(res.data.headType4Tension ?? 100);
          })
          .catch(() => {
            tensionValuesFailed = true;
            this.toast.error(this.$t("editCustomSetting.errorInUpdatingStitchData") as string, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          });
        if (tensionValuesFailed) return;
        this.validateDefaultcm0();
        this.validateDefaultcm1();
        this.validateDefaultcm2();
        this.validateDefaultcm3();
        if (!this.needleError && !this.underError && !this.topError && !this.tensionError) {
          const stitchTypeComponent: StitchTypeDto = { ...this.editStitchComponentData };
          stitchTypeComponent.defaultBight! *= this.bightConversionFactor;
          stitchTypeComponent.stdStitchRate =
            Math.round((stitchTypeComponent.stdStitchRate as number) * this.rateConversionFactor * 10000) / 10000;

          await this.stitchTypeApi
            .apiUpdateStitchTypePut(stitchTypeComponent)
            .then(async out => {
              if (out.data) {
                const code = this.editStitchComponentData.code as string;
                await this.getStitchTypeData();
                if (code != "") {
                  await this.getConsumptionData(code);
                  const stitchValue = this.stitchComponentData.find((a: { code: string }) => a.code == code);

                  if (stitchValue) {
                    this.editStitchComponentData.defaultwaste = stitchValue.defaultwaste.toFixed(2);
                    this.editStitchComponentData.stdStitchRate = (
                      stitchValue.stdStitchRate / this.rateConversionFactor
                    ).toFixed(2) as unknown as number;
                  }

                  this.getNeedleData(code);
                  this.setConsumptionValues(code);
                }
                this.toast.success(this.$t("editCustomSetting.stitchDataUpdatedSuccessfully") as string, {
                  toastClassName: "custom-success-toast",
                  timeout: 5000
                });
              } else {
                this.toast.error(this.$t("editCustomSetting.errorInUpdatingStitchData") as string, {
                  toastClassName: "custom-error-toast",
                  timeout: 5000
                });
              }
            })
            .catch(() => {
              this.toast.error(this.$t("editCustomSetting.errorInUpdatingStitchData") as string, {
                toastClassName: "custom-error-toast",
                timeout: 5000
              });
            });
        }
      }
      if (this.needleError) {
        this.toast.error(this.$t("editCustomSetting.pleaseEnterCorrectNeedleValue") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      if (this.underError) {
        this.toast.error(this.$t("editCustomSetting.pleaseEnterCorrectUnderValue") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      if (this.topError) {
        this.toast.error(this.$t("editCustomSetting.pleaseEnterCorrectTopValue") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      if (this.tensionError) {
        this.toast.error(this.$t("editCustomSetting.pleaseEnterCorrectTensionValue") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      if (this.wasteError) {
        this.toast.error(this.$t("editCustomSetting.pleaseEnterCorrectWasteValue") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      if (this.bightError) {
        this.toast.error(this.$t("editCustomSetting.pleaseEnterCorrectBightValue") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      if (this.stitchRateError) {
        this.toast.error(this.$t("editCustomSetting.pleaseEnterCorrectStitchRateValue") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      if (this.seamThiknessError) {
        this.toast.error(this.$t("editCustomSetting.pleaseEnterCorrectSeamThicknessValue") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    async updateCustomSetting(): Promise<void> {
      await this.customSettingsApi
        .apiUpdateCustomSettingPost(this.customSettings.isDefaultSettingId, this.customSettings)
        .then(async res => {
          if (res.data) {
            this.savedAllowance = Number(this.customSettings.defaultAllowance) || 0;
            await this.getConsumptionData();
            let stitchTypeCode = this.stitchTypeName?.split("-")[0];
            if (stitchTypeCode != "") {
              this.getNeedleData(stitchTypeCode);
              this.setConsumptionValues(stitchTypeCode);
            }
            this.toast.success(this.$t("editCustomSetting.settingUpdatedSuccessfully") as string, {
              toastClassName: "custom-success-toast",
              timeout: 5000
            });
            this.$emit("getCustomSettingsData");
            this.$emit("save");
          } else {
            this.toast.error(this.$t("editCustomSetting.errorInUpdatingSetting") as string, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          }
        });
    }
  }
});
</script>
<style scoped>
.body {
  display: grid;
  margin-top: 15px;
}
.name {
  background-color: #dbe3ea;
  width: 35rem;
  height: 35px;
  border-radius: 10px;
  text-indent: 20px;
}
.counter {
  float: right;
  position: relative;
  top: -31px;
  right: 8px;
  z-index: 99999;
}
.lastChanged {
  font-size: 12px;
  color: #a09d9d;
  padding: 6px;
}
.stitch {
  width: 5rem;
  height: 2rem;
  border: 1px solid #ced4da;
  border-radius: 5px;
}
.consumptionData {
  width: 5rem;
  height: 2.25rem;
  padding: 6px 8px !important;
  text-align: right;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
}
.consumptionData:disabled {
  background-color: #f1f5f9;
  color: #64748b;
}
.consumptionTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  overflow: hidden;
  font-size: 14px;
  color: #334155;
}
.consumptionTable thead th {
  background-color: #ffffff;
  color: #1f2937;
  font-weight: 600;
  white-space: nowrap;
  padding: 14px 16px;
  text-align: left;
  border-bottom: 1px solid #e3e8ef;
}
.consumptionTable thead th.num,
.consumptionTable td.num {
  text-align: center;
}
.consumptionTable thead th.right,
.consumptionTable td.right {
  text-align: right;
}
.consumptionTable tbody td {
  padding: 12px 16px;
  border-bottom: 1px solid #eef2f6;
  vertical-align: middle;
}
.consumptionTable td.op,
.consumptionTable th.op {
  width: 28px;
  text-align: center;
  color: #94a3b8;
}
.consumptionTable .unit {
  color: #64748b;
  margin-left: 6px;
}
.consumptionTable .strongValue {
  font-weight: 600;
  color: #1f2937;
}
.consumptionTable .allowanceNote {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 2px;
  white-space: nowrap;
}
/* spells out how the two calculated columns are worked out */
.consumptionNote {
  margin-top: 12px;
  font-size: 13px;
  line-height: 1.5;
  color: #94a3b8;
}
/* names the Allowance the wastage was calculated at, and why (US-146957 AC4) */
.allowanceMessage {
  margin-top: 16px;
  padding: 12px 16px;
  font-size: 14px;
  color: #334155;
  background-color: #f1f5f9;
  border-left: 3px solid #0054a6;
  border-radius: 4px;
}
.consumptionTable tfoot td {
  background-color: #eef2f7;
  font-weight: 700;
  color: #1f2937;
  padding: 14px 16px;
  border-top: 1px solid #e3e8ef;
}
.vue-js-switch .v-switch-input {
  position: relative !important;
  opacity: 0 !important;
  width: 40px !important;
  height: 40px !important;
  top: 12px !important;
  left: 7px !important;
  z-index: 1000 !important;
}
.vue-js-switch .v-switch-core {
  display: block !important;
  position: relative !important;
  box-sizing: border-box !important;
  outline: 0 !important;
  margin: 0 !important;
  transition:
    border-color 0.3s,
    background-color 0.3s !important;
  top: -19px !important;
  left: 5px !important;
  user-select: none !important;
}
.vue-js-switch .v-switch-label {
  position: absolute !important;
  top: 9.5px !important;
  left: 30px !important;
  font-weight: 600 !important;
  color: #0054a6 !important;
  z-index: 1 !important;
}
.k-dialog-wrapper {
  align-items: flex-end !important;
}
.k-window-titlebar {
  color: #000000 !important;
  background-color: #ffffff !important;
}
.b-toaster {
  z-index: 999999 !important;
}
.k-input {
  font-size: 12px !important;
  padding: 0px 0px !important;
}
.k-slider-horizontal {
  width: 100% !important;
  max-width: 450px !important;
}
.form-input {
  height: 40px;
  border-radius: 10px;
  width: 208%;
  text-align: center;
}
.form-input:focus {
  box-shadow: 0 0 0 2px #b3c1d0 !important;
}
.btn-primary {
  background-color: #0054a6;
  color: white;
}
.modal-backdrop {
  z-index: 10400;
}

.modal-right {
  width: 100%;
}
.modal-header {
  background-color: #0054a6;
  color: white;
  padding: 0.75rem;
  height: auto;
  border-top-left-radius: 0 !important;
}

.modal.right .modal-dialog {
  position: fixed;
  margin: 0;
  right: -1;
  top: 0;
  bottom: 0;
  height: 100%;
  /* widened to fit the Wastage Added and Total After Wastage columns (US-146957) */
  width: 1000px;
  max-width: 100vw;
  font-family: Arial, Helvetica, sans-serif;
  color: white;
}
.modal.right .modal-content {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 0 !important;
}

body.modal-open {
  overflow-x: hidden;
  border-radius: 0 !important;
}
.modal-header i.fa-times {
  color: white !important;
}
.modal {
  pointer-events: none !important;
}
input[type="radio"].form-check-input:checked {
  background-color: #ffffff;
  border-color: #858585;
  background-image: radial-gradient(circle at center, #858585 50%, transparent 40%);
}
.form-check-input {
  box-shadow: 0 0 0 0.25rem rgba(255, 255, 255, 0.75) !important;
}
input[type="checkbox"].form-check-input:checked {
  background-color: #858585 !important;
}
td {
  vertical-align: middle !important;
}
.stitchComponent {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 0;
  flex-wrap: nowrap;
  align-items: flex-start;
  position: relative;
}
.leftComponent {
  flex: 0 1 auto;
  margin: 0;
  min-width: 0;
  max-width: 75%;
  padding-right: 5px;
}
.rightComponent {
  margin-left: auto;
  min-width: 180px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 0;
}
.rightComponent table {
  width: auto;
}
.stitchTypeRow {
  width: 100%;
}
/* The dropdown spans the full panel width so its edges line up with the Stitch/3CM
   and Waste(%) inputs below; the 7px matches those tables' border-spacing (US-146957). */
.stitchType {
  display: grid;
  width: 100%;
  padding: 13px 7px;
}
</style>
